import React from 'react';
import PropTypes from 'prop-types';
import withInit from 'WithInit';

const ReactivationOfferModal = ({
  reactivationPage,
}) => {
  const trackAndRedirect = () => {
    window._track('Get Started | Reactivation Modal', reactivationPage);
    window.location.assign('/my-account?skip_start_reactivation=1');
  };

  return (
    <React.Fragment>
      <div className="modal-header">
        <button className="close" data-dismiss="modal">X</button>
        <h3>This feature requires a paid subscription.</h3>
      </div>
      <div className="modal-body">
        <p className="reactivate-yours">
          Reactivate yours now for $37 per month.
        </p>
        <p className="reactivation-seconds">It only takes a few seconds.</p>
      </div>
      <div className="modal-footer">
        <div className="buttons center">
          <a className="btn btn-success btn-large" onClick={trackAndRedirect}>Get Started</a>
        </div>
      </div>
    </React.Fragment>
  );
};

ReactivationOfferModal.propTypes = {
  reactivationPage: PropTypes.string.isRequired,
};

export default withInit(ReactivationOfferModal);



// WEBPACK FOOTER //
// ./src-react/Modals/ReactivationOfferModal/index.jsx